import * as React from "react";
import Cross from "@bolteu/kalep-react-icons/dist/Cross";
import { cx } from "../../helpers/utils/cx";
import { IconButton } from "../IconButton";
export function UploadAttachments(_ref) {
  let {
    files,
    onRemoveFile,
    fullWidth,
    renderEndSlot
  } = _ref;
  if (!files || !files.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx(fullWidth ? "w-full" : "w-96")
  }, files.map(file => /*#__PURE__*/React.createElement(UploadAttachment, {
    key: file.name,
    file: file,
    onRemove: onRemoveFile,
    renderEndSlot: renderEndSlot
  })));
}
export function UploadAttachment(props) {
  const {
    file,
    renderEndSlot = renderEndSlotDefault,
    onRemove: _onRemove
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: cx("flex items-center gap-2 py-3 px-4")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("flex flex-col flex-1")
  }, /*#__PURE__*/React.createElement("span", {
    className: cx("bolt-font-body-m-regular break-all")
  }, file.name), /*#__PURE__*/React.createElement("span", {
    className: cx("bolt-font-body-s-regular text-secondary")
  }, getHumanFileSize(file.size), " - ", file.type)), /*#__PURE__*/React.createElement("div", {
    className: cx("flex-shrink-0")
  }, renderEndSlot(props)));
}
function renderEndSlotDefault(props) {
  const {
    onRemove
  } = props;
  if (typeof onRemove === "function") {
    // eslint-disable-next-line react/jsx-no-bind -- can't do useCallback here :(
    return /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Remove file",
      icon: /*#__PURE__*/React.createElement(Cross, null),
      onClick: () => onRemove(props.file),
      size: "sm"
    });
  }
  return null;
}
function getHumanFileSize(size) {
  if (size < 1000000) {
    return `${(size / 1024).toFixed(2)}KiB`;
  }
  return `${(size / 1024 / 1024).toFixed(2)}MiB`;
}